/**
 * Enum que definen los tipos de alertas.
 * En cada uno se establece el icono asociado.
 *
 * @author Diego Armando Ortiz Bastidas <dortiz@heinsohn.com.co>
 */
export enum TypeAlertEnum {
  SUCCESS = 'mdi:checkbox-marked-circle-outline',
  WARNING = 'ci:triangle-warning',
  INFO = 'cuida:info-outline',
  ERROR = 'lets-icons:close-ring',
  GENERIC = 'solar:dialog-linear',
  DELETE = 'mage:trash'
}
